import React from 'react';
import * as Styled from '../styled'; // Import styled components
import type { Person } from '../hooks';

interface BaseProfileProps {
  userInfo?: Person;
  profileName: string;
  standAlone: boolean;
}

export const BaseProfile = (props: BaseProfileProps) => {
  const { userInfo, profileName, standAlone } = props;

  const handleLogout = () => {
    window.location.href = '/login';
  };

  return (
    <div>
      <Styled.BaseProfileDiv>
        <Styled.BaseProfileTitle>My Profile</Styled.BaseProfileTitle>

        {standAlone && <Styled.LogoutButton onClick={handleLogout}>Logout</Styled.LogoutButton>}

        {userInfo?.userName && (
          <Styled.InfoSection>
            <Styled.InfoLabel>Email Address</Styled.InfoLabel>
            <div>{userInfo?.userName}</div>
          </Styled.InfoSection>
        )}

        {userInfo?.customerName && (
          <Styled.InfoSection>
            <Styled.InfoLabel>Viewing Account</Styled.InfoLabel>
            <div>{userInfo.customerName}</div>
          </Styled.InfoSection>
        )}

        {userInfo?.role && (
          <Styled.InfoSection>
            <Styled.InfoLabel>User Role</Styled.InfoLabel>
            <div>{userInfo?.role}</div>
          </Styled.InfoSection>
        )}
      </Styled.BaseProfileDiv>

      <Styled.SectionHeader>{profileName}</Styled.SectionHeader>
    </div>
  );
};
